import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import Swal from 'sweetalert2';
import httpService from '../services/http.service';
import { currency_format, t } from '../utils';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { isFullScreen, toogleFullScreen } from '../fullscreen';
import { Modal } from 'bootstrap';
import uuid from 'react-uuid';
import { ArrowRightIcon, XCircleIcon, Squares2X2Icon, ArrowPathIcon, ArrowLeftIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { UserCircleIcon } from '@heroicons/react/24/solid';
const priceFilterList = ['Retail Prices', 'Wholesale Prices', 'Super Dealer Prices'];
const decodeScaleBarcode = (barcode) => {
    const trimmed = (barcode || '').trim();
    if (!/^\d{13}$/.test(trimmed) || !trimmed.startsWith('20')) {
        return null;
    }
    let sum = 0;
    for (let i = 0; i < 12; i++) {
        const digit = parseInt(trimmed.charAt(i), 10);
        const weight = (i % 2 === 0) ? 1 : 3;
        sum += digit * weight;
    }
    const mod = sum % 10;
    const checkDigit = (mod === 0) ? 0 : 10 - mod;
    if (parseInt(trimmed.charAt(12), 10) !== checkDigit) {
        return null;
    }
    const plu = trimmed.substring(2, 6);
    const rawWeight = parseInt(trimmed.substring(6, 12), 10);
    const weight = Number((rawWeight / 1000).toFixed(3));
    return { plu, weight };
};
class PointOfSale extends Component {
    constructor(props) {
        super(props);
        this.specialCustomerPrice = (prod) => {
            if (!this.state.customer)
                return prod.price || 0;
            if (this.state.customer.order_details.length == 0)
                return prod.price || 0;
            var newProd = this.state.customer.order_details.find(p => p.product_id === prod.id);
            if (!newProd)
                return prod.price || 0;
            return newProd.price || 0;
        };
        this.getCategories = () => {
            // console.log("ASDASD");
            httpService
                .get(`inventory/categories`)
                .then((response) => {
                this.setState({ categories: response.data.data });
            })
                .finally(() => {
                this.setState({ isLoadingCategories: false });
            });
        };
        this.storeOrder = () => {
            var _b;
            for (let i = 0; i < this.state.cart.length; i++) {
                const item = this.state.cart[i];
                if (item.track_stock && !item.continue_selling_when_out_of_stock) {
                    if (item.in_stock - ((_b = item.quantity) !== null && _b !== void 0 ? _b : 0) < 0) {
                        toast.error(t('Out of stock for ' + item.name + '!', 'إنتهى من المخزن!'));
                        return;
                    }
                }
            }
            if (this.state.cart.length == 0) {
                toast.error(t('No items has been added!', 'لم يتم إضافة اية اصناف!'));
                return;
            }
            this.setState({ isLoading: true });
            var _deliveryCharge = 0;
            if (this.getAppSettings().enableTakeoutAndDelivery) {
                _deliveryCharge = this.isOrderDelivery() ? this.state.deliveryCharge || 0 : 0;
            }
            else {
                _deliveryCharge = this.state.deliveryCharge || 0;
            }
            // console.log(this.state.cart);
            httpService
                .post(`/order`, {
                customer: this.state.customer,
                cart: this.state.cart,
                subtotal: this.state.subtotal,
                total: this.state.total,
                tax_rate: this.state.tax || 0,
                vat_type: this.state.vatType,
                delivery_charge: _deliveryCharge,
                discount: this.state.discount || 0,
                remarks: this.state.remarks,
                type: this.state.orderType,
                tender_amount: this.state.tenderAmount || 0,
                return_amount: this.state.returnAmount || 0,
                price_type: this.state.currentPrice || 0,
                paid: this.state.isPaid,
                is_quotation: this.state.isQuotation
            })
                .then((response) => {
                if (response.data) {
                    this.resetPos();
                    toast.info(t('Saved!', 'تم الحفظ'));
                    this.closeModal('checkoutModal');
                    // console.log(response.data);
                    this.printInvoice(response.data, this.getAppSettings());
                }
            })
                .finally(() => {
                this.setState({ isLoading: false });
            });
        };
        this.reset = () => {
            Swal.fire({
                title: t('Reset?', 'إعادة ضبط'),
                text: t('Any unsaved changes will be lost', 'ستفقد أي تغييرات غير محفوظة'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: t('Reset?', 'إعادة ضبط'),
                cancelButtonText: t('Cancel', 'إلغاء')
            }).then(result => {
                if (result.isConfirmed) {
                    this.resetPos();
                }
            });
        };
        this.resetPos = () => {
            var settings = this.getAppSettings();
            this.setState({ products: [] });
            this.setState({ cart: [] });
            this.setState({ customers: [] });
            this.setState({ customer: undefined });
            this.setState({ customerName: null });
            this.setState({ customerEmail: null });
            this.setState({ customerMobile: null });
            this.setState({ customerCity: null });
            this.setState({ customerBuilding: null });
            this.setState({ customerStreet: null });
            this.setState({ customerFloor: null });
            this.setState({ customerApartment: null });
            this.setState({ showProducts: false });
            this.setState({ categoryName: '' });
            this.setState({ subtotal: 0 });
            this.setState({ deliveryCharge: settings.deliveryCharge });
            this.setState({ total: 0 });
            this.setState({ discount: settings.discount });
            this.setState({ tax: settings.taxRate });
            this.setState({ vatType: settings.vatType });
            this.setState({ searchValue: null });
            this.setState({ remarks: null });
            this.setState({ tenderAmount: 0 });
            this.setState({ returnAmount: 0 });
            this.setState({ customerAmount: 0 });
            this.setState({ isLoading: false });
            this.setState({ selectItem: 'first' });
            this.setState({ isPaid: true });
            this.setState({ isQuotation: false });
        };
        this.togglePaidButton = () => {
            this.setState({ isPaid: !this.state.isPaid });
        };
        this.categoryClick = (category) => {
            this.setState({ showProducts: true });
            this.setState({ selectItem: category.id });
            this.setState({ products: category.products || [] });
            this.setState({ categoryName: category.name });
        };
        this.backClick = () => {
            this.setState({ showProducts: false });
            this.setState({ products: [] });
            this.setState({ categoryName: '' });
            this.setState({ selectItem: 'first' });
        };
        this.handleDiscountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var discountValue = value == '' ? undefined : Number(value);
            this.setState({ discount: discountValue }, () => {
                this.calculateTotal();
            });
        };
        this.handleTaxChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var taxValue = value == '' ? undefined : Number(value);
            this.setState({ tax: taxValue }, () => {
                this.calculateTotal();
            });
        };
        this.handleDeliveryChargeChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var deliveryChargeValue = value == '' ? undefined : Number(value);
            this.setState({ deliveryCharge: deliveryChargeValue }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemPrice = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.price = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemQtyByClick = (event, item, qty) => {
            var value = qty;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.quantity = Number(value) || 1;
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.toggleFullScreen = () => {
            toogleFullScreen();
            this.setState({ isFullScreen: !this.state.isFullScreen });
        };
        this.goToDashboard = () => {
            window.location.href = '/';
        };
        this.calculateItemPrice = (item) => {
            let price = ((item.price || 0) * (item.quantity || 0) * (100 - Number(item.discount || 0))) / 100.0;
            if (item.vat_type === 'add')
                price = price + (price * Number(item.tax_rate)) / 100;
            else
                price = price - (price * Number(item.tax_rate)) / 100;
            return Number(price.toFixed(2));
        };
        this.calculateTotal = () => {
            let _total = 0;
            let _subtotal = 0;
            let _discount = 0;
            if (this.state.cart.length > 0) {
                this.state.cart.map((item) => {
                    // console.log(item.retailsale_price);
                    // console.log(item.wholesale_price);
                    let item_discount = 0;
                    item_discount = ((item.price || 0) * (item.quantity || 0) * (item.discount || 0)) / 100;
                    _subtotal += (item.price || 0) * (item.quantity || 0);
                    _discount += item_discount;
                    // _subtotal += ((this.state.currentPrice === 0 ? item.retailsale_price : item.wholesale_price) || 0) * (item.quantity || 0);
                });
            }
            let taxValue = 0;
            if (this.state.vatType == 'add') {
                if ((this.state.tax || 0) > 0 && (this.state.tax || 0) <= 100) {
                    taxValue = (Number(this.state.tax || 0) * Number(_subtotal)) / 100;
                }
            }
            var deliveryCharge = 0;
            if (this.getAppSettings().enableTakeoutAndDelivery) {
                if (this.isOrderDelivery()) {
                    deliveryCharge = Number(this.state.deliveryCharge || 0);
                }
            }
            else {
                deliveryCharge = Number(this.state.deliveryCharge || 0);
            }
            _total = Number(_subtotal) + Number(taxValue) + Number(deliveryCharge) - Number(_discount || 0);
            this.setState({ subtotal: _subtotal });
            this.setState({ total: _total });
            this.setState({ tenderAmount: _total });
            this.setState({ discount: _discount });
        };
        this.getVat = () => {
            var vat = this.state.tax || 0;
            if (vat <= 0)
                return 0;
            var grossAmount = this.state.subtotal || 0;
            var taxAmount = this.getTaxAmount();
            return Math.round(Number(grossAmount) - Number(taxAmount));
        };
        this.getTaxAmount = () => {
            var vat = this.state.tax || 0;
            if (vat <= 0)
                return 0;
            var grossAmount = this.state.subtotal || 0;
            return Math.trunc(Number(grossAmount) / Number(Number(1) + Number(vat) / Number(100)));
        };
        this.getTotalTax = () => {
            let taxValue = 0;
            if (Number(this.state.tax || 0) > 0 && Number(this.state.tax || 0) <= 100) {
                taxValue = (Number(this.state.tax || 0) * Number(this.state.subtotal)) / 100;
            }
            return Number(taxValue);
        };
        this.getChangeAmount = () => {
            return (this.state.tenderAmount || 0) - this.state.total;
        };
        this.handleTenderAmountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var tenderAmount = value == '' ? undefined : Number(value);
            this.setState({ tenderAmount: tenderAmount });
        };
        this.handleCustomerAmountChange = (event) => {
            var value = event.target.value;
            if (Number(value) < 0)
                return;
            var customerAmount = value == '' ? undefined : Number(value);
            this.setState({
                customerAmount,
                returnAmount: (!customerAmount ? 0 : customerAmount) - (!this.state.tenderAmount ? 0 : this.state.tenderAmount)
            });
        };
        this.handleRemarksChange = (event) => {
            this.setState({ remarks: event.currentTarget.value });
        };
        this.removeItem = (item) => {
            let newCartItems = this.state.cart.filter(i => i.cartId != item.cartId);
            this.setState({ cart: newCartItems }, () => this.calculateTotal());
        };
        this.addToCart = (product) => {
            let unitPrice = (product.price_per_kg && Number(product.price_per_kg) > 0)
                ? Number(product.price_per_kg)
                : (this.state.currentPrice === 0 ? product.retailsale_price : product.wholesale_price);
            let cartItem = {
                cartId: uuid(),
                id: product.id,
                name: product.name,
                full_name: product.full_name,
                image_url: product.image_url,
                price: unitPrice,
                wholesale_price: product.wholesale_price,
                retailsale_price: product.retailsale_price,
                price_per_kg: product.price_per_kg,
                // barcode: product.barcode,
                wholesale_barcode: product.wholesale_barcode,
                retail_barcode: product.retail_barcode,
                imei_barcode: product.imei_barcode,
                // sku: product.sku,
                wholesale_sku: product.wholesale_sku,
                retail_sku: product.retail_sku,
                retail_net_wt: product.retail_net_wt,
                wholesale_net_wt: product.wholesale_net_wt,
                in_stock: product.in_stock,
                track_stock: product.track_stock,
                continue_selling_when_out_of_stock: product.continue_selling_when_out_of_stock,
                quantity: 1,
                vat_type: this.getAppSettings().vatType,
                tax_rate: 0,
                discount: 0
            };
            this.setState({ selectItem: 'first' });
            this.setState({ cart: [cartItem, ...this.state.cart] }, () => {
                this.calculateTotal();
            });
            if (this.state.hasaudio) {
                new Audio('/audio/public_audio_ding.mp3').play();
            }
        };
        this.handleSearchSubmit = (event) => {
            var _b;
            event.preventDefault();
            const search = this.state.searchValue;
            if (!search)
                return;
            let searchValue = search.toLowerCase().trim();
            // 1. Scale Barcode Handling (13-digit EAN-13 starting with Flag '20')
            if (/^\d{13}$/.test(searchValue) && searchValue.startsWith('20')) {
                const decoded = decodeScaleBarcode(searchValue);
                if (!decoded) {
                    toast.error(t('Invalid or unrecognized scale barcode', 'باركود ميزان غير صالح أو غير معروف'));
                    this.setState({ searchValue: null });
                    const searchInput = document.getElementById('barcode-input');
                    if (searchInput)
                        searchInput.value = '';
                    return;
                }
                let allProducts = [];
                this.state.categories.forEach((category) => {
                    allProducts.push(...(category.products || []));
                });
                const scaleProduct = allProducts.find(p => p.sold_by_weight && (p.plu_code === decoded.plu || (p.plu_code && p.plu_code.padStart(4, '0') === decoded.plu)));
                if (scaleProduct) {
                    const pricePerKg = Number(scaleProduct.price_per_kg) || Number(scaleProduct.retailsale_price) || 0;
                    this.addScaleItemToCart(scaleProduct, decoded.weight, pricePerKg);
                    this.setState({ searchValue: null });
                    const searchInput = document.getElementById('barcode-input');
                    if (searchInput)
                        searchInput.value = '';
                    return;
                }
                // Not found in local state, fetch from server
                httpService
                    .post('/pos/find-or-create', { barcode: searchValue })
                    .then((response) => {
                    if (response.data && response.data.success && response.data.data) {
                        const newProd = response.data.data;
                        const weight = response.data.data.scanned_weight !== undefined ? response.data.data.scanned_weight : decoded.weight;
                        const price = response.data.data.price_per_kg !== undefined ? response.data.data.price_per_kg : (newProd.price_per_kg || newProd.retailsale_price || 0);
                        let categories = [...this.state.categories];
                        if (categories.length > 0) {
                            if (!categories[0].products)
                                categories[0].products = [];
                            categories[0].products.push(newProd);
                            this.setState({ categories });
                        }
                        this.addScaleItemToCart(newProd, weight, Number(price));
                        this.setState({ searchValue: null });
                        const searchInput = document.getElementById('barcode-input');
                        if (searchInput)
                            searchInput.value = '';
                    }
                    else {
                        toast.error(t('Invalid or unrecognized scale barcode', 'باركود ميزان غير صالح أو غير معروف'));
                    }
                })
                    .catch((err) => {
                    console.error('Error scanning scale barcode:', err);
                    toast.error(t('Invalid or unrecognized scale barcode', 'باركود ميزان غير صالح أو غير معروف'));
                });
                return;
            }
            // 2. Normal barcode search logic for non-scale products
            const last6 = searchValue.length >= 6 ? searchValue.slice(-6) : null;
            let productFound = 0;
            let allProducts = [];
            this.state.categories.forEach((category) => {
                allProducts.push(...(category.products || []));
            });
            // Exact Match
            let exactMatches = allProducts.filter((p) => {
                var _b, _j, _k, _q, _v;
                const retailBarcodes = (((_b = p.retail_barcode) === null || _b === void 0 ? void 0 : _b.toString()) || '').split(',').map(b => b.trim().toLowerCase()).filter(Boolean);
                const wholesaleBarcodes = (((_j = p.wholesale_barcode) === null || _j === void 0 ? void 0 : _j.toString()) || '').split(',').map(b => b.trim().toLowerCase()).filter(Boolean);
                const retailSku = ((_k = p.retail_sku) === null || _k === void 0 ? void 0 : _k.toString().toLowerCase().trim()) || '';
                const wholesaleSku = ((_q = p.wholesale_sku) === null || _q === void 0 ? void 0 : _q.toString().toLowerCase().trim()) || '';
                const imeiBarcode = ((_v = p.imei_barcode) === null || _v === void 0 ? void 0 : _v.toString().toLowerCase().trim()) || '';
                return (retailBarcodes.includes(searchValue) ||
                    wholesaleBarcodes.includes(searchValue) ||
                    retailSku === searchValue ||
                    wholesaleSku === searchValue ||
                    imeiBarcode === searchValue);
            });
            // Last 6 Digits Match
            let last6Matches = [];
            if (exactMatches.length === 0 && last6) {
                last6Matches = allProducts.filter((p) => {
                    var _b, _j, _k, _q, _v;
                    const retailBarcodes = (((_b = p.retail_barcode) === null || _b === void 0 ? void 0 : _b.toString()) || '').split(',').map(b => b.trim().toLowerCase()).filter(Boolean);
                    const wholesaleBarcodes = (((_j = p.wholesale_barcode) === null || _j === void 0 ? void 0 : _j.toString()) || '').split(',').map(b => b.trim().toLowerCase()).filter(Boolean);
                    const retailSku = ((_k = p.retail_sku) === null || _k === void 0 ? void 0 : _k.toString().toLowerCase().trim()) || '';
                    const wholesaleSku = ((_q = p.wholesale_sku) === null || _q === void 0 ? void 0 : _q.toString().toLowerCase().trim()) || '';
                    const imeiBarcode = ((_v = p.imei_barcode) === null || _v === void 0 ? void 0 : _v.toString().toLowerCase().trim()) || '';
                    return (retailBarcodes.some(b => b === last6 || b.endsWith(last6)) ||
                        wholesaleBarcodes.some(b => b === last6 || b.endsWith(last6)) ||
                        retailSku === last6 ||
                        wholesaleSku === last6 ||
                        imeiBarcode === last6);
                });
            }
            // Name search
            let nameMatches = [];
            if (exactMatches.length === 0 && last6Matches.length === 0 && !/^\d{10,14}$/.test(searchValue)) {
                nameMatches = allProducts.filter((p) => {
                    var _b;
                    const name = ((_b = p.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || '';
                    return name.includes(searchValue);
                });
            }
            const matches = exactMatches.length > 0 ? exactMatches : (last6Matches.length > 0 ? last6Matches : nameMatches);
            if (matches.length > 1 && exactMatches.length === 0 && last6Matches.length === 0) {
                toast.error(t('Multiple products found, please refine search', 'تم العثور على أكثر من منتج'));
                return;
            }
            let _prod = matches[0];
            if (!_prod) {
                httpService
                    .post('/pos/find-or-create', {
                    barcode: searchValue,
                })
                    .then((response) => {
                    if (response.data && response.data.success && response.data.data) {
                        const newProd = response.data.data;
                        let categories = [...this.state.categories];
                        if (categories.length > 0) {
                            if (!categories[0].products)
                                categories[0].products = [];
                            categories[0].products.push(newProd);
                            this.setState({ categories });
                        }
                        let unitPrice = (newProd.price_per_kg && Number(newProd.price_per_kg) > 0)
                            ? Number(newProd.price_per_kg)
                            : (this.state.currentPrice === 0 ? (newProd.retailsale_price || 0) : (newProd.wholesale_price || newProd.retailsale_price || 0));
                        this.addToCartWithOverrides(newProd, 1, unitPrice);
                        this.setState({ searchValue: null });
                        const searchInput = document.getElementById('barcode-input');
                        if (searchInput)
                            searchInput.value = '';
                    }
                    else {
                        toast.error(t('No results found!', 'لم يتم العثور على نتائج!'));
                    }
                })
                    .catch((err) => {
                    console.error('Error finding barcode item:', err);
                    toast.error(t('No results found!', 'لم يتم العثور على نتائج!'));
                });
                return;
            }
            let overridePrice = (this.state.currentPrice === 0 ? _prod.retailsale_price : (_prod.wholesale_price || _prod.retailsale_price)) || 0;
            for (let i = 0; i < this.state.cart.length; i++) {
                if (_prod.id === this.state.cart[i].id) {
                    productFound = 2;
                    const newQty = Number((((_b = this.state.cart[i].quantity) !== null && _b !== void 0 ? _b : 0) + 1).toFixed(3));
                    if (this.state.cart[i].track_stock &&
                        !this.state.cart[i].continue_selling_when_out_of_stock &&
                        newQty > this.state.cart[i].in_stock) {
                        toast.error(t('Out of stock for ' + this.state.cart[i].name + '!', 'إنتهى من المخزن!'));
                        return;
                    }
                    this.state.cart[i].quantity = newQty;
                    this.setState({ cart: this.state.cart }, () => {
                        this.calculateTotal();
                    });
                    break;
                }
            }
            if (productFound !== 2) {
                if (_prod.track_stock && !_prod.continue_selling_when_out_of_stock) {
                    if (1 > _prod.in_stock) {
                        toast.error(t('Out of stock for ' + _prod.name + '!', 'إنتهى من المخزن!'));
                        return;
                    }
                }
                this.addToCartWithOverrides(_prod, 1, overridePrice);
                productFound = 1;
            }
            if (productFound === 1 || productFound === 2) {
                this.setState({ searchValue: null });
                const searchInput = document.getElementById('barcode-input');
                if (searchInput)
                    searchInput.value = '';
            }
        };
        this.addScaleItemToCart = (product, weightKg, unitPrice) => {
            let cartItem = {
                cartId: uuid(),
                id: product.id,
                name: product.name,
                full_name: product.full_name,
                image_url: product.image_url,
                price: unitPrice,
                wholesale_price: product.wholesale_price,
                retailsale_price: product.retailsale_price,
                price_per_kg: unitPrice,
                wholesale_barcode: product.wholesale_barcode,
                retail_barcode: product.retail_barcode,
                imei_barcode: product.imei_barcode,
                wholesale_sku: product.wholesale_sku,
                retail_sku: product.retail_sku,
                retail_net_wt: product.retail_net_wt,
                wholesale_net_wt: product.wholesale_net_wt,
                in_stock: product.in_stock,
                track_stock: product.track_stock,
                continue_selling_when_out_of_stock: product.continue_selling_when_out_of_stock,
                quantity: weightKg,
                sold_by_weight: true,
                plu_code: product.plu_code,
                vat_type: this.getAppSettings().vatType,
                tax_rate: 0,
                discount: 0
            };
            this.setState({ selectItem: 'first', cart: [cartItem, ...this.state.cart] }, () => {
                this.calculateTotal();
            });
            if (this.state.hasaudio) {
                new Audio('/audio/public_audio_ding.mp3').play();
            }
        };
        this.promptEditWeight = (item) => {
            Swal.fire({
                title: t('Edit Weight (kg)', 'تعديل الوزن (كغ)'),
                input: 'number',
                inputAttributes: {
                    step: '0.001',
                    min: '0.001',
                    max: '999.999',
                    placeholder: '0.000'
                },
                inputValue: (Number(item.quantity) || 0).toFixed(3),
                showCancelButton: true,
                confirmButtonText: t('Save', 'حفظ'),
                cancelButtonText: t('Cancel', 'إلغاء'),
                inputValidator: (value) => {
                    if (!value || parseFloat(value) <= 0) {
                        return t('Please enter a valid weight in kg', 'يرجى إدخال وزن صالح بالكيلوغرام');
                    }
                    return null;
                }
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    const newWeight = parseFloat(result.value);
                    const newCart = this.state.cart.map(c => {
                        if (c.cartId === item.cartId) {
                            return Object.assign(Object.assign({}, c), { quantity: Number(newWeight.toFixed(3)) });
                        }
                        return c;
                    });
                    this.setState({ cart: newCart }, () => this.calculateTotal());
                }
            });
        };
        this.addToCartWithOverrides = (product, weightKg, overridePrice = null) => {
            let unitPrice = overridePrice !== null
                ? overridePrice
                : ((product.price_per_kg && Number(product.price_per_kg) > 0)
                    ? Number(product.price_per_kg)
                    : (this.state.currentPrice === 0 ? product.retailsale_price : product.wholesale_price));
            let cartItem = {
                cartId: uuid(),
                id: product.id,
                name: product.name,
                full_name: product.full_name,
                image_url: product.image_url,
                price: unitPrice,
                wholesale_price: product.wholesale_price,
                retailsale_price: product.retailsale_price,
                price_per_kg: product.price_per_kg,
                wholesale_barcode: product.wholesale_barcode,
                retail_barcode: product.retail_barcode,
                imei_barcode: product.imei_barcode,
                wholesale_sku: product.wholesale_sku,
                retail_sku: product.retail_sku,
                retail_net_wt: product.retail_net_wt,
                wholesale_net_wt: product.wholesale_net_wt,
                in_stock: product.in_stock,
                track_stock: product.track_stock,
                continue_selling_when_out_of_stock: product.continue_selling_when_out_of_stock,
                quantity: weightKg !== null ? weightKg : 1,
                sold_by_weight: product.sold_by_weight,
                plu_code: product.plu_code,
                vat_type: this.getAppSettings().vatType,
                tax_rate: 0,
                discount: 0
            };
            this.setState({ selectItem: 'first' });
            this.setState({ cart: [cartItem, ...this.state.cart] }, () => {
                this.calculateTotal();
            });
            if (this.state.hasaudio) {
                new Audio('/audio/public_audio_ding.mp3').play();
            }
        };
        this.handleSearchChange = (event) => {
            this.setState({ searchValue: event.currentTarget.value });
        };
        this.handleVatTypeChange = (event) => {
            this.setState({ vatType: event.target.value }, () => {
                this.calculateTotal();
            });
        };
        this.handleSelectItem = (e) => {
            console.log(e.currentTarget.value);
            let categoryTemp = this.state.categories.find(category => category.id === e.currentTarget.value);
            if (categoryTemp === null || categoryTemp === void 0 ? void 0 : categoryTemp.id) {
                this.categoryClick(categoryTemp);
            }
        };
        this.handleCustomerSearchChange = (event) => {
            var searchQuery = event.currentTarget.value.trim();
            if (!searchQuery) {
                this.setState({ customers: [] });
                return;
            }
            httpService
                .get(`/customers/search/all?query=${searchQuery}`)
                .then((response) => {
                this.setState({ customers: response.data.data });
            })
                .finally(() => { });
        };
        this.setCustomer = (customer) => {
            this.setState({ customer: customer });
        };
        this.closeModal = (id) => {
            const createModal = document.querySelector(`#${id}`);
            if (createModal) {
                var modalInstance = Modal.getInstance(createModal);
                if (modalInstance) {
                    modalInstance.hide();
                }
            }
        };
        this.getAppSettings = () => {
            return JSON.parse(this.props.settings);
        };
        this.currencyFormatValue = (number) => {
            var settings = this.getAppSettings();
            return currency_format(number, settings.currencyPrecision, settings.currencyDecimalSeparator, settings.currencyThousandSeparator, settings.currencyPosition, settings.currencySymbol, settings.trailingZeros);
        };
        // convertToDollar = (): string => {
        //     var settings = this.getAppSettings();
        //     if (!settings.exchangeRate || Number(settings.exchangeRate) === 0) return '';
        //     var dollarValue = Number(this.state.total) / Number(settings.exchangeRate);
        //     return '$ ' + dollarValue.toFixed(2);
        // };
        this.convertToUSD = (amount) => {
            const settings = this.getAppSettings();
            if (!settings.exchangeRate || Number(settings.exchangeRate) === 0)
                return '';
            const usd = Number(amount) / Number(settings.exchangeRate);
            if (isNaN(usd))
                return '';
            return '$ ' + usd.toFixed(2);
        };
        this.receiptExchangeRate = () => {
            var settings = this.getAppSettings();
            var value = Number(this.state.total) * Number(settings.exchangeRate);
            return currency_format(value, 2, '.', ',', 'before', settings.exchangeCurrency, true);
        };
        this.isProductAvailable = (product) => {
            if (product.continue_selling_when_out_of_stock)
                return true;
            if (!product.track_stock)
                return true;
            if (product.in_stock > 0)
                return true;
            return false;
        };
        this.updateItemQuantity = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.quantity = value == '' ? undefined : Math.floor(Number(value));
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemVatType = (item) => {
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            _prod.vat_type = item.vat_type === 'exclude' ? 'add' : 'exclude';
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemVAT = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.tax_rate = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.updateItemDiscount = (event, item) => {
            var value = event.target.value;
            let cartItems = this.state.cart;
            let _prod = this.state.cart.find(p => p.cartId === item.cartId);
            if (!_prod)
                return;
            if (Number(value) < 0)
                return;
            _prod.discount = value == '' ? undefined : Number(value);
            this.setState({ cart: cartItems }, () => {
                this.calculateTotal();
            });
        };
        this.createCustomer = (e) => {
            e.preventDefault();
            if (!this.state.customerName) {
                toast.error(t('Customer name is required!', 'اسم الزبون مطلوب!'));
                return;
            }
            this.setState({ isLoading: true });
            httpService
                .post(`/customers/create-new`, {
                name: this.state.customerName,
                email: this.state.customerEmail,
                mobile: this.state.customerMobile,
                city: this.state.customerCity,
                building: this.state.customerBuilding,
                street_address: this.state.customerStreet,
                floor: this.state.customerFloor,
                apartment: this.state.customerApartment
            })
                .then((response) => {
                this.setCustomer(response.data.data);
                this.setState({ customerName: '' });
                this.setState({ customerEmail: '' });
                this.setState({ customerMobile: '' });
                this.setState({ customerBuilding: '' });
                this.setState({ customerStreet: '' });
                this.setState({ customerFloor: '' });
                this.setState({ customerApartment: '' });
                var form = document.getElementById('create-customer-form');
                if (form) {
                    form.reset();
                }
                this.closeModal('customerModal');
                toast.info(t('Customer has been created', 'تم إنشاء زبون جديد'));
            })
                .finally(() => {
                this.setState({ isLoading: false });
            });
        };
        this.handleCustomerNameChange = (event) => {
            this.setState({ customerName: event.currentTarget.value });
        };
        this.handleCustomerEmailChange = (event) => {
            this.setState({ customerEmail: event.currentTarget.value });
        };
        this.handleCustomerMobileChange = (event) => {
            this.setState({ customerMobile: event.currentTarget.value });
        };
        this.handleCustomerCityChange = (event) => {
            this.setState({ customerCity: event.currentTarget.value });
        };
        this.handleCustomerStreetChange = (event) => {
            this.setState({ customerStreet: event.currentTarget.value });
        };
        this.handleCustomerBuildingChange = (event) => {
            this.setState({ customerBuilding: event.currentTarget.value });
        };
        this.handleCustomerFloorChange = (event) => {
            this.setState({ customerFloor: event.currentTarget.value });
        };
        this.handleCustomerApartmentChange = (event) => {
            this.setState({ customerApartment: event.currentTarget.value });
        };
        this.printInvoice = (data, settings) => {
            window.open(`/orders/print/${data.order.id}`, '_blank');
        };
        this.oldprintInvoice = (data, settings) => {
            var receipt = window.open(``, 'PRINT', 'height=600,width=300');
            var order = data.order;
            var barcode = data.barcode;
            if (!receipt)
                return;
            receipt.document.write(`<html lang="${settings.lang}" dir="${settings.dir}"><head><title>Order Receipt ${order.number}</title></head><body>`);
            receipt.document.write(`<div style="margin-bottom: 1.5rem;text-align: center !important;">`);
            const logoPath = './images/new_logo.png'; // Local relative path to your logo image
            receipt.document.write(`<div style="text-align: center; margin-bottom: 10px;">
                <img src="${logoPath}" alt="Store Logo" style="width: 100px; height: auto;">
            </div>`);
            if (settings.storeAddress) {
                receipt.document.write(`<div style="font-size: 1rem;">${settings.storeAddress}</div>`);
            }
            if (settings.storePhone) {
                receipt.document.write(`<div style="font-size: 1rem;">${settings.storePhone}</div>`);
            }
            if (settings.storeWebsite) {
                receipt.document.write(`<div style="font-size: 0.875em;">${settings.storeWebsite}</div>`);
            }
            if (settings.storeEmail) {
                receipt.document.write(`<div style="font-size: 0.875em;">${settings.storeEmail}</div>`);
            }
            receipt.document.write(`</div>`);
            receipt.document.write('<div style="margin: 1.5rem">');
            order.order_details.map((detail) => {
                if (receipt) {
                    receipt.document.write(`<div>`);
                    receipt.document.write(`<div>${detail.product.name}</div>`);
                    receipt.document.write(`<div style="display: flex">`);
                    receipt.document.write(`<div>${detail.quantity}* ${detail.view_price}</div>`);
                    receipt.document.write(`
    <div style="${settings.margin}: auto; text-align: right;">
        <div>${detail.view_total}</div>
        <div style="font-size: 0.8em;">
            ${this.convertToUSD(detail.total)}
        </div>
    </div>
`);
                    receipt.document.write('</div>');
                    receipt.document.write('</div>');
                }
            });
            receipt.document.write('</div>');
            if (order.discount > 0) {
                receipt.document.write('<div style="display: flex;margin: 1.5rem">');
                receipt.document.write(`<div>${t('Discount', 'الخصم')}</div>`);
                receipt.document.write(`
    <div style="${settings.margin}: auto; text-align: right;">
        <div>${order.discount_view}</div>
        <div style="font-size: 0.8em;">
            ${this.convertToUSD(order.discount)}
        </div>
    </div>
`);
                receipt.document.write('</div>');
            }
            if (this.getAppSettings().enableTakeoutAndDelivery) {
                if (this.isOrderDelivery()) {
                    if (order.delivery_charge > 0) {
                        receipt.document.write('<div style="display: flex;margin: 1.5rem">');
                        receipt.document.write(`<div>${t('Delivery Charge', 'رسوم التوصيل')}:</div>`);
                        receipt.document.write(`
    <div style="${settings.margin}: auto; text-align: right;">
        <div>${order.delivery_charge_view}</div>
        <div style="font-size: 0.8em;">
            ${this.convertToUSD(order.delivery_charge)}
        </div>
    </div>
`);
                        receipt.document.write('</div>');
                    }
                }
            }
            else {
                if (order.delivery_charge > 0) {
                    receipt.document.write('<div style="display: flex;margin: 1.5rem">');
                    receipt.document.write(`<div>${t('Delivery Charge', 'رسوم التوصيل')}:</div>`);
                    receipt.document.write(`
    <div style="${settings.margin}: auto; text-align: right;">
        <div>${order.delivery_charge_view}</div>
        <div style="font-size: 0.8em;">
            ${this.convertToUSD(order.delivery_charge)}
        </div>
    </div>
`);
                    receipt.document.write('</div>');
                }
            }
            if (order.tax_rate > 0) {
                if (order.vat_type == 'add') {
                    receipt.document.write('<div style="display: flex;margin: 1.5rem">');
                    receipt.document.write(`<div>${t('VAT', 'الضريبة')} (${order.tax_rate}%):</div>`);
                    receipt.document.write(`
    <div style="${settings.margin}: auto; text-align: right;">
        <div>${order.total_tax_view}</div>
        <div style="font-size: 0.8em;">
            ${this.convertToUSD(order.total_tax)}
        </div>
    </div>
`);
                    receipt.document.write('</div>');
                }
                else {
                    receipt.document.write('<div style="display: flex;margin: 1.5rem">');
                    receipt.document.write(`<div>${t('Subtotal', 'المجموع')}</div>`);
                    receipt.document.write(`
    <div style="${settings.margin}: auto; text-align: right;">
        <div>${order.subtotal_view}</div>
        <div style="font-size: 0.8em;">
            ${this.convertToUSD(order.subtotal)}
        </div>
    </div>
`);
                    receipt.document.write('</div>');
                    receipt.document.write('<div style="display: flex;margin: 1.5rem">');
                    receipt.document.write(`<div>${t('TAX.AMOUNT', 'قيمة الضريبة')}</div>`);
                    receipt.document.write(`
    <div style="${settings.margin}: auto; text-align: right;">
        <div>${order.tax_amount_view}</div>
        <div style="font-size: 0.8em;">
            ${this.convertToUSD(order.tax_amount)}
        </div>
    </div>
`);
                    receipt.document.write('</div>');
                    receipt.document.write('<div style="display: flex;margin: 1.5rem">');
                    receipt.document.write(`<div>${t('VAT', 'الضريبة')} ${order.tax_rate}%:</div>`);
                    receipt.document.write(`
    <div style="${settings.margin}: auto; text-align: right;">
        <div>${order.vat_view}</div>
        <div style="font-size: 0.8em;">
            ${this.convertToUSD(order.vat)}
        </div>
    </div>
`);
                    receipt.document.write('</div>');
                }
            }
            if (order.return_amount && order.return_amount > 0) {
                receipt.document.write('<div style="display: flex; margin: 1.5rem;">');
                receipt.document.write(`<div>${t('Customer Return', 'المبلغ المسترد')}</div>`);
                receipt.document.write(`
        <div style="${settings.margin}: auto; text-align: right;">
            <div>${order.return_amount_view || this.currencyFormatValue(order.return_amount)}</div>
            <div style="font-size: 0.8em;">
                ${this.convertToUSD(order.return_amount)}
            </div>
        </div>
    `);
                receipt.document.write('</div>');
            }
            receipt.document.write(`<div style="display: flex; font-weight: 700; margin: 1.5rem;">`);
            receipt.document.write(`<div>${t('Total', 'المجموع')}</div>`);
            receipt.document.write(`
    <div style="${settings.margin}: auto; text-align: right;">
        <div>${order.total_view}</div>
        <div style="font-weight: normal; font-size: 0.9em;">
            ${this.convertToUSD(order.total)}
        </div>
    </div>
`);
            receipt.document.write('</div>');
            receipt.document.write('<div style="text-align: center !important;margin-bottom: 0.5rem !important;">');
            receipt.document.write(`<span style="margin-right: 1rem">${order.date_view}</span> <span>${order.time_view}</span>`);
            receipt.document.write('</div>');
            receipt.document.write(`<div style="text-align: center !important;margin-bottom: 0.5rem !important;">${order.number}</div>`);
            receipt.document.write(`<div style="display: flex;align-items: center !important;justify-content: center">${barcode}</div>`);
            if (settings.storeAdditionalInfo) {
                receipt.document.write(`<div style="font-size: 0.875em;text-align: center !important;margin-bottom: 0.5rem !important;">${settings.storeAdditionalInfo}</div>`);
            }
            receipt.document.write('</body></html>');
            receipt.document.close();
            // receipt.focus();
            // receipt.print();
            // receipt.close();
        };
        this.modalCloseButton = () => {
            return React.createElement("button", { type: "button", className: "btn-close", "data-bs-dismiss": "modal", "aria-label": "Close" });
        };
        this.modalCloseButtonWhite = () => {
            return React.createElement("button", { type: "button", className: "btn-close btn-close-white", "data-bs-dismiss": "modal", "aria-label": "Close" });
        };
        this.handleOrderTypeChange = (event) => {
            this.setState({ orderType: event.target.value }, () => {
                this.calculateTotal();
            });
        };
        this.isOrderDelivery = () => {
            return this.state.orderType == 'delivery';
        };
        this.allProducts = () => {
            var products = [];
            this.state.categories.map((category) => {
                category.products.map((product) => {
                    products.push(product);
                });
            });
            return products;
        };
        this.handleCloseModal = () => {
            this.closeModal('checkoutModal');
        };
        this.handleIsQuotationChange = (event) => {
            this.setState({
                isQuotation: event.target.value == 'Quotation'
            });
        };
        this.pricesFilter = () => {
            return (React.createElement("div", { className: "dropdown" },
                React.createElement("button", { type: "button", className: "nav-link bg-white border px-3 py-2 rounded-3 clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#myModal" },
                    React.createElement("div", { className: "d-flex align-items-center" },
                        React.createElement("div", { className: "d-flex justify-content-between align-items-center" },
                            React.createElement("div", { className: "me-5" }, priceFilterList[this.state.currentPrice]),
                            React.createElement(ChevronDownIcon, { className: "hero-icon-xs" }))))));
        };
        this.handleSelectRadio = (index) => {
            const cart = this.state.cart.map((item) => {
                let cartItem = {
                    cartId: uuid(),
                    id: item.id,
                    name: item.name,
                    full_name: item.full_name,
                    image_url: item.image_url,
                    price: index === 0 ? item.retailsale_price : item.wholesale_price,
                    wholesale_price: item.wholesale_price,
                    retailsale_price: item.retailsale_price,
                    // barcode: item.barcode,
                    wholesale_barcode: item.wholesale_barcode,
                    retail_barcode: item.retail_barcode,
                    imei_barcode: item.imei_barcode,
                    // sku: item.sku,
                    wholesale_sku: item.wholesale_sku,
                    retail_sku: item.retail_sku,
                    in_stock: item.in_stock,
                    track_stock: item.track_stock,
                    continue_selling_when_out_of_stock: item.continue_selling_when_out_of_stock,
                    quantity: 1,
                    vat_type: item.vat_type,
                    discount: item.discount,
                    tax_rate: item.tax_rate
                };
                return cartItem;
            });
            this.setState({ cart: cart, currentPrice: index }, () => {
                this.calculateTotal();
            });
            this.closeModal('myModal');
        };
        this.pricesFilterModal = () => {
            return (React.createElement("div", { className: "modal zoom-out-entrance", id: "myModal", tabIndex: -1, "aria-labelledby": "myModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("div", { className: "d-flex justify-content-between w-100 user-select-none cursor-pointer", onClick: () => this.handleSelectRadio(0) },
                                React.createElement("div", null, priceFilterList[0]),
                                React.createElement("input", { type: "radio", checked: this.state.currentPrice === 0 }))),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("div", { className: "d-flex justify-content-between user-select-none cursor-pointer", onClick: () => this.handleSelectRadio(1) },
                                React.createElement("div", null, priceFilterList[1]),
                                React.createElement("input", { type: "radio", checked: this.state.currentPrice === 1 }))),
                        React.createElement("div", { className: "modal-footer" },
                            React.createElement("div", { className: "d-flex justify-content-between w-100 user-select-none cursor-pointer", onClick: () => this.handleSelectRadio(2) },
                                React.createElement("div", null, priceFilterList[2]),
                                React.createElement("input", { type: "radio", checked: this.state.currentPrice === 2 })))))));
        };
        this.state = {
            categories: [],
            products: [],
            cart: [],
            customers: [],
            customer: undefined,
            customerName: null,
            customerEmail: null,
            customerMobile: null,
            customerCity: null,
            customerBuilding: null,
            customerStreet: null,
            customerFloor: null,
            customerApartment: null,
            showProducts: false,
            categoryName: null,
            orderType: 'takeout',
            subtotal: 0,
            total: 0,
            tax: 0,
            vatType: this.getAppSettings().vatType,
            deliveryCharge: 0,
            hasaudio: true,
            discount: 0,
            searchValue: null,
            remarks: null,
            isFullScreen: isFullScreen(),
            tenderAmount: 0,
            returnAmount: 0,
            customerAmount: 0,
            isLoading: false,
            isLoadingCategories: true,
            selectItem: 'first',
            currentPrice: 0,
            isPaid: true,
            isQuotation: false
        };
    }
    componentDidMount() {
        var settings = this.getAppSettings();
        this.setState({ tax: settings.taxRate });
        this.setState({ deliveryCharge: settings.deliveryCharge });
        this.setState({ discount: settings.discount });
        this.setState({ hasaudio: settings.newItemAudio });
        this.setState({ vatType: settings.vatType });
        this.getCategories();
        this.calculateTotal();
        this.setState({ tenderAmount: this.state.total });
        window.onbeforeunload = event => {
            return 'Are you sure?';
        };
    }
    selectCustomer(customer) {
        this.setState({ customer: customer });
        this.closeModal('customerModal');
    }
    removeCustomer() {
        this.setState({ customer: undefined });
    }
    render() {
        var _b;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex py-3" },
                React.createElement("div", { className: "d-flex flex-grow-1" },
                    React.createElement("div", { className: "flex-grow-1 d-flex" },
                        React.createElement("button", { className: "btn btn-primary me-2", onClick: event => this.goToDashboard() },
                            React.createElement("span", { className: "d-flex align-items-center" },
                                React.createElement(Squares2X2Icon, { className: "hero-icon me-1" }),
                                " ",
                                t('Dashboard', 'الرئيسية'))),
                        React.createElement("button", { className: "btn btn-light me-3 bg-white border", "data-bs-toggle": "modal", "data-bs-target": "#customerModal" },
                            React.createElement("span", { className: "d-flex align-items-center" },
                                React.createElement(UserCircleIcon, { className: "hero-icon me-1" }),
                                " ",
                                t('Customer', 'الزبون'))),
                        React.createElement("button", { className: "btn btn-danger me-5", onClick: event => this.reset() },
                            React.createElement("span", { className: "d-flex align-items-center" },
                                React.createElement(ArrowPathIcon, { className: "hero-icon me-1" }),
                                " ",
                                t('Reset?', 'إعادة ضبط'))),
                        React.createElement("select", { name: "is_quotation", id: "is_quotation", className: "form-select w-auto px-5", defaultValue: "Invoice", onChange: e => this.handleIsQuotationChange(e) },
                            React.createElement("option", { value: "Inovoice" }, t('Invoice', 'فاتورة')),
                            React.createElement("option", { value: "Quotation" }, t('Quotation', 'اقتباس')))),
                    this.pricesFilter(),
                    this.pricesFilterModal()),
                React.createElement("div", { className: "d-flex" }, this.getAppSettings().enableTakeoutAndDelivery && (React.createElement("select", { name: "order-type", id: "order-type", className: "form-select px-5 mx-2", defaultValue: "takeout", onChange: e => this.handleOrderTypeChange(e) },
                    React.createElement("option", { value: "takeout" }, t('Takeout', 'أستلام')),
                    React.createElement("option", { value: "delivery" }, t('Delivery', 'توصيل')))))),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("div", { className: "card w-100 card-gutter rounded-0" },
                        React.createElement("div", { className: "card-header bg-white border-bottom-0 p-0" },
                            React.createElement("form", { onSubmit: event => this.handleSearchSubmit(event) },
                                React.createElement("input", { type: "search", className: "form-control form-control-lg rounded-0", name: "search", id: "barcode-input", placeholder: t('Scan barcode or IMEI or search by name or SKU', 'امسح الباركود ضوئيًا أو ابحث بالاسم أو SKU'), onChange: event => this.handleSearchChange(event) }))),
                        React.createElement("div", { className: "card-body p-0 overflow-auto", id: "cartItems" },
                            React.createElement("table", { className: "table table-bordered mb-0" },
                                React.createElement("thead", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 300, className: "p-3 fw-bold" }, t('Item', 'الصنف')),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" }, t('Quantity', 'الكمية')),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" },
                                            t('VAT', 'الضريبة'),
                                            " %"),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" },
                                            t('Discount', 'الخصم'),
                                            " %"),
                                        React.createElement("td", { width: 150, className: "text-center p-3 fw-bold" }, t('Total', 'المجموع')))),
                                React.createElement("tbody", null, this.state.cart.length > 0 ? (React.createElement(React.Fragment, null, this.state.cart.map((item) => {
                                    return (React.createElement("tr", { key: item.cartId },
                                        React.createElement("td", { width: 300 },
                                            React.createElement("div", { className: "d-flex mb-2" },
                                                React.createElement("div", { className: "d-flex flex-grow-1" },
                                                    React.createElement("div", { className: "me-2 d-flex align-items-center" },
                                                        React.createElement("img", { src: item.image_url, alt: "img", className: "rounded-2", height: 50 })),
                                                    React.createElement("div", null,
                                                        React.createElement("div", { className: "fw-bold" },
                                                            this.state.categoryName ? `${this.state.categoryName} - ` : '',
                                                            item.full_name || item.name),
                                                        React.createElement("div", { className: "fw-normal" },
                                                            React.createElement("input", { type: "number", className: "form-control text-center form-control-sm mt-1", value: item.price, title: "Unit Price", onFocus: e => e.target.select(), onChange: e => this.updateItemPrice(e, item) })))),
                                                React.createElement("div", { className: "me-auto d-flex align-items-center" },
                                                    React.createElement(XCircleIcon, { className: "hero-icon-sm align-middle text-danger cursor-pointer user-select-none", onClick: event => this.removeItem(item) })))),
                                        React.createElement("td", { width: 150, className: "p-0 align-middle text-center" }, item.sold_by_weight ? (React.createElement("div", { className: "d-flex flex-column align-items-center justify-content-center py-1" },
                                            React.createElement("div", { className: "d-flex align-items-center" },
                                                React.createElement("span", { className: "badge bg-info text-dark me-1", style: { fontSize: '0.65rem' } }, "\u2696\uFE0F Scale"),
                                                React.createElement("span", { className: "fw-bold fs-6" },
                                                    (Number(item.quantity) || 0).toFixed(3),
                                                    " kg"),
                                                React.createElement("button", { type: "button", className: "btn btn-sm btn-link text-primary p-0 ms-1", title: t('Edit Weight (kg)', 'تعديل الوزن (كغ)'), onClick: () => this.promptEditWeight(item) },
                                                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "14", fill: "currentColor", className: "bi bi-pencil", viewBox: "0 0 16 16" },
                                                        React.createElement("path", { d: "M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" })))),
                                            React.createElement("small", { className: "text-muted", style: { fontSize: '0.75rem' } },
                                                "@ ",
                                                this.currencyFormatValue(item.price || 0),
                                                " / kg"))) : (React.createElement("input", { type: "number", className: "form-control text-center fw-bold form-control-lg", value: item.quantity, onFocus: e => e.target.select(), onChange: event => this.updateItemQuantity(event, item) }))),
                                        React.createElement("td", { width: 150, className: "p-0 align-middle text-center" },
                                            React.createElement("div", { onClick: event => this.updateItemVatType(item) }, item.vat_type),
                                            React.createElement("input", { type: "number", className: "form-control text-center fw-bold form-control-lg", value: item.tax_rate, onFocus: e => e.target.select(), onChange: event => this.updateItemVAT(event, item) })),
                                        React.createElement("td", { width: 150, className: "p-0 align-middle text-center" },
                                            React.createElement("input", { type: "number", className: "form-control text-center fw-bold form-control-lg", value: item.discount, onFocus: e => e.target.select(), onChange: event => this.updateItemDiscount(event, item) })),
                                        React.createElement("td", { width: 150, className: "text-center align-middle" }, this.calculateItemPrice(item))));
                                }))) : (React.createElement(React.Fragment, null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { colSpan: 5, className: "p-3 text-center align-middle fs-5" }, t('No items added...', 'لا توجد اصناف مضافة ...')))))))),
                        React.createElement("div", { className: " card-footer p-0 bg-white", id: "orderDetails" },
                            React.createElement("table", { className: "table table-bordered mb-0" },
                                React.createElement("tbody", null,
                                    React.createElement("tr", null,
                                        React.createElement("td", { colSpan: 3, width: 200, className: "text-center align-end clickable-cell", onClick: this.togglePaidButton }, this.state.isPaid === true ? 'Paid' : 'Unpaid')),
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 200 },
                                            t('Customer', 'الزبون'),
                                            ":",
                                            ' ',
                                            this.state.customer ? React.createElement("span", { className: "fw-bold" }, this.state.customer.name) : 'N/A',
                                            this.state.customer && (React.createElement("div", { className: "float-end" },
                                                React.createElement(XCircleIcon, { className: "hero-icon-sm align-middle text-danger cursor-pointer user-select-none", onClick: event => this.removeCustomer() })))),
                                        React.createElement("td", { width: 200, className: "text-end" }, t('Subtotal', 'المجموع')),
                                        React.createElement("td", { width: 200, className: "align-middle text-center" },
                                            React.createElement("div", null, this.currencyFormatValue(this.state.subtotal)),
                                            React.createElement("div", { className: "text-muted small" }, this.getAppSettings().exchangeRate && Number(this.getAppSettings().exchangeRate) > 0
                                                ? '$ ' + (Number(this.state.subtotal) / Number(this.getAppSettings().exchangeRate)).toFixed(2)
                                                : ''))),
                                    React.createElement("tr", null,
                                        React.createElement("td", { width: 200, className: "text-start align-middle clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#deliveryChargeModal" }, this.getAppSettings().enableTakeoutAndDelivery ? (React.createElement(React.Fragment, null, this.isOrderDelivery() && (React.createElement(React.Fragment, null,
                                            t('Delivery Charge', 'رسوم التوصيل'),
                                            " :",
                                            ' ',
                                            this.state.deliveryCharge
                                                ? this.currencyFormatValue(this.state.deliveryCharge)
                                                : 'N/A')))) : (React.createElement(React.Fragment, null,
                                            t('Delivery Charge', 'رسوم التوصيل'),
                                            " :",
                                            ' ',
                                            this.state.deliveryCharge ? this.currencyFormatValue(this.state.deliveryCharge) : 'N/A'))),
                                        React.createElement("td", { width: 200, className: "text-end align-middle clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#discountModal" }, t('Discount', 'الخصم')),
                                        React.createElement("td", { width: 200, className: "text-center text-danger align-middle clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#discountModal" },
                                            React.createElement("div", null, this.currencyFormatValue(this.state.discount || 0)),
                                            React.createElement("div", { className: "small" }, this.getAppSettings().exchangeRate && Number(this.getAppSettings().exchangeRate) > 0
                                                ? '$ ' +
                                                    (Number(this.state.discount || 0) / Number(this.getAppSettings().exchangeRate)).toFixed(2)
                                                : ''))),
                                    React.createElement("tr", { className: "alert-success" },
                                        this.state.vatType == 'add' ? (React.createElement("td", { width: 200, className: "text-start clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#taxModal" },
                                            t('VAT', 'الضريبة'),
                                            " ",
                                            this.state.tax,
                                            "%: ",
                                            this.currencyFormatValue(this.getTotalTax()))) : (React.createElement("td", { width: 200, className: "text-start clickable-cell", "data-bs-toggle": "modal", "data-bs-target": "#taxModal" },
                                            React.createElement("div", null,
                                                t('TAX.AMOUNT', 'قيمة الضريبة'),
                                                ": ",
                                                this.currencyFormatValue(this.getTaxAmount())),
                                            React.createElement("div", null,
                                                t('VAT', 'الضريبة'),
                                                " ",
                                                this.state.tax,
                                                "%: ",
                                                this.currencyFormatValue(this.getVat())))),
                                        React.createElement("td", { width: 200, className: "fw-bold text-end fs-5 align-middle" }, t('Total', 'الإجمالي')),
                                        React.createElement("td", { width: 200, className: "text-center align-middle fw-bold fs-5" },
                                            React.createElement("div", null, this.currencyFormatValue(this.state.total)),
                                            React.createElement("div", { className: "text-muted fs-6 fw-normal" }, this.convertToUSD(this.state.total))))))),
                        React.createElement("button", { type: "button", className: "btn btn-success py-4 rounded-0 shadow-sm fs-3 btn-lg w-100", "data-bs-toggle": "modal", "data-bs-target": "#checkoutModal" }, t('CHECKOUT', 'الدفع')))),
                React.createElement("div", { className: "col-md-6" },
                    React.createElement("div", { className: "card w-100 card-gutter rounded-0" },
                        React.createElement("div", { className: "card-header bg-white" },
                            React.createElement("div", { className: "d-flex px-4 justify-content-between align-items-center", style: { minHeight: 'calc(1.5em + 1rem + 5px)', padding: '0.5rem' } },
                                React.createElement("div", { className: "d-flex align-items-center" },
                                    React.createElement("a", { className: "text-decoration-none cursor-pointer pe-2 fs-5", onClick: event => this.backClick() }, t('CATEGORIES', 'الفئات')),
                                    this.state.showProducts && (React.createElement("div", { className: "d-flex align-items-center" },
                                        this.getAppSettings().dir == 'rtl' ? (React.createElement(ArrowLeftIcon, { className: "hero-icon pe-2" })) : (React.createElement(ArrowRightIcon, { className: "hero-icon pe-2" })),
                                        React.createElement("span", { className: "fw-normal text-muted pe-2 fs-5 text-uppercase", "aria-current": "page" }, this.state.categoryName),
                                        this.getAppSettings().dir == 'rtl' ? (React.createElement(ArrowLeftIcon, { className: "hero-icon pe-2" })) : (React.createElement(ArrowRightIcon, { className: "hero-icon pe-2" }))))),
                                React.createElement("select", { name: "product", className: "form-control w-50", value: this.state.selectItem, onChange: e => this.handleSelectItem(e) },
                                    React.createElement("option", { value: "first" }, "Select item"),
                                    this.state.categories.length > 0 &&
                                        this.state.categories.map((item) => React.createElement("option", { value: item.id }, item.name))))),
                        React.createElement("div", { className: "card-body overflow-auto py-0" },
                            this.state.isLoadingCategories && (React.createElement("div", { className: "py-5" },
                                React.createElement("div", { className: "d-flex justify-content-center m-2" },
                                    React.createElement("div", { className: "spinner-border text-primary", role: "status", style: { width: '4rem', height: '4rem' } },
                                        React.createElement("span", { className: "visually-hidden" }, t('Loading...', 'جاري التحميل...')))),
                                React.createElement("div", { className: "fw-bold h3 text-center" }, t('Loading...', 'جاري التحميل...')))),
                            !this.state.showProducts && (React.createElement(React.Fragment, null, this.state.categories.length > 0 && (React.createElement("div", { className: "row" }, this.state.categories.map((category) => {
                                return (React.createElement("div", { key: category.id, className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                    React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.categoryClick(category) },
                                        React.createElement("picture", null,
                                            React.createElement("source", { type: "image/jpg", srcSet: category.image_url }),
                                            React.createElement("img", { alt: category.name, src: category.image_url, "aria-hidden": "true", className: "object-fit-cover h-100 w-100" })),
                                        React.createElement("div", { className: "position-absolute bottom-0 start-0 h-100 d-flex flex-column align-items-center justify-content-center p-4 mb-0 w-100 cell-item-label text-center" },
                                            React.createElement("div", { className: "product-name", dir: "auto" }, category.name)))));
                            }))))),
                            this.state.showProducts && (React.createElement(React.Fragment, null, this.state.products.length > 0 && (React.createElement("div", { className: "row overflow-auto" }, this.state.products.map((product) => {
                                return (React.createElement(React.Fragment, null, this.isProductAvailable(product) && (React.createElement("div", { key: product.id, className: "col-lg-4 col-md-4 col-sm-6 col-6 mb-0 p-0" },
                                    React.createElement("div", { className: "position-relative w-100 border cursor-pointer user-select-none", onClick: event => this.addToCart(product) },
                                        React.createElement("picture", null,
                                            React.createElement("source", { type: "image/jpg", srcSet: product.image_url }),
                                            React.createElement("img", { alt: product.name, src: product.image_url, "aria-hidden": "true", className: "object-fit-cover h-100 w-100" })),
                                        React.createElement("div", { className: "position-absolute bottom-0 start-0 h-100 d-flex flex-column align-items-center justify-content-center p-4 mb-0 w-100 cell-item-label text-center" },
                                            React.createElement("div", { className: "fw-normal" }, this.currencyFormatValue((this.state.currentPrice === 0
                                                ? product.retailsale_price
                                                : product.wholesale_price) || 0)),
                                            React.createElement("div", { className: "fw-bold", dir: "auto" }, product.full_name),
                                            React.createElement("div", { className: "fw-normal" }, product.in_stock)))))));
                            }))))))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "discountModal", tabIndex: -1, "aria-labelledby": "discountModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "discountModalLabel" }, t('Discount', 'الخصم')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" }, this.currencyFormatValue(this.state.discount || 0)),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", onFocus: e => e.target.select(), value: this.state.discount, onChange: this.handleDiscountChange })))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "deliveryChargeModal", tabIndex: -1, "aria-labelledby": "deliveryChargeModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title d-flex", id: "deliveryChargeModalLabel" }, t('Delivery Charge', 'رسوم التوصيل')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" }, this.currencyFormatValue(this.state.deliveryCharge || 0)),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: this.state.deliveryCharge, onChange: this.handleDeliveryChargeChange, onFocus: e => e.target.select() })))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "taxModal", tabIndex: -1, "aria-labelledby": "taxModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "taxModalLabel" }, t('VAT', 'الضريبة')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body" },
                            React.createElement("h3", { className: "text-center" },
                                this.state.tax || 0,
                                "%"),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", onFocus: e => e.target.select(), value: this.state.tax, onChange: this.handleTaxChange })),
                            React.createElement("div", { className: "mb-3" },
                                React.createElement("select", { name: "vatType", id: "vat-type", className: "form-select form-select-lg", onChange: this.handleVatTypeChange, value: this.state.vatType },
                                    React.createElement("option", { value: "exclude" },
                                        " ",
                                        t('Exclude', 'استثناء')),
                                    React.createElement("option", { value: "add" }, t('Add', 'إضافة')))))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "customerModal", tabIndex: -1, "aria-labelledby": "customerModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title d-flex", id: "customerModalLabel" }, t('Customer', 'الزبون')),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body p-0" },
                            React.createElement("nav", null,
                                React.createElement("div", { className: "nav nav-tabs nav-justified", id: "nav-tab", role: "tablist" },
                                    React.createElement("button", { className: "nav-link rounded-0 active", id: "nav-search-customer-tab", "data-bs-toggle": "tab", "data-bs-target": "#nav-search-customer", type: "button", role: "tab", "aria-controls": "nav-search-customer", "aria-selected": "true" }, t('Search', 'ابحث')),
                                    React.createElement("button", { className: "nav-link rounded-0", id: "nav-create-customer-tab", "data-bs-toggle": "tab", "data-bs-target": "#nav-create-customer", type: "button", role: "tab", "aria-controls": "nav-create-customer", "aria-selected": "false" }, t('Create', 'إنشاء')))),
                            React.createElement("div", { className: "tab-content", id: "nav-tabContent" },
                                React.createElement("div", { className: "tab-pane fade show active", id: "nav-search-customer", role: "tabpanel", "aria-labelledby": "nav-search-customer-tab", tabIndex: 0 },
                                    React.createElement("div", { className: "position-relative w-100" },
                                        React.createElement("input", { type: "search", className: "form-control form-control-lg rounded-0 shadow-none", name: "search", id: "search", autoComplete: "off", placeholder: t('Search...', 'بحث...'), onChange: event => this.handleCustomerSearchChange(event) })),
                                    React.createElement("div", { className: "overflow-auto", style: { height: '250px' } }, this.state.customers.length > 0 && (React.createElement(React.Fragment, null, this.state.customers.map((cuts) => {
                                        return (React.createElement("div", { className: "py-2 px-3 clickable-cell border-bottom", onClick: e => this.selectCustomer(cuts), key: cuts.id },
                                            React.createElement("div", { className: "fw-bold" }, cuts.name),
                                            React.createElement("div", { className: "small text-muted" }, cuts.contact),
                                            React.createElement("div", { className: "small text-muted" }, cuts.full_address)));
                                    }))))),
                                React.createElement("div", { className: "tab-pane fade p-3", id: "nav-create-customer", role: "tabpanel", "aria-labelledby": "nav-create-customer-tab", tabIndex: 0 },
                                    React.createElement("form", { method: "POST", onSubmit: this.createCustomer, role: "form", id: "create-customer-form" },
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" },
                                                t('Customer Name', 'اسم الزبون'),
                                                "*"),
                                            React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerNameChange(event) })),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('Email', 'البريد الإلكتروني')),
                                            React.createElement("input", { type: "email", className: "form-control form-control-lg", onChange: event => this.handleCustomerEmailChange(event) })),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('Mobile Number', 'رقم الجوال')),
                                            React.createElement("input", { type: "tel", className: "form-control form-control-lg", onChange: event => this.handleCustomerMobileChange(event) })),
                                        React.createElement("div", { className: "text-muted" }, t('Address', 'العنوان')),
                                        React.createElement("div", { className: "mb-3" },
                                            React.createElement("label", { className: " form-label fw-bold" }, t('City', 'المدينة')),
                                            React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerCityChange(event) })),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Street', 'الشارع')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerStreetChange(event) })),
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Building', 'المبنى')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerBuildingChange(event) }))),
                                        React.createElement("div", { className: "row" },
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Floor', 'الطابق')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerFloorChange(event) })),
                                            React.createElement("div", { className: "col-md-6 mb-3" },
                                                React.createElement("label", { className: " form-label fw-bold" }, t('Apartment', 'الشقة')),
                                                React.createElement("input", { type: "text", className: "form-control form-control-lg", onChange: event => this.handleCustomerApartmentChange(event) }))),
                                        React.createElement("button", { className: "btn btn-primary btn-lg w-100", type: "submit", disabled: this.state.isLoading }, t('Create Customer', 'إنشاء زبون جديد'))))))))),
            React.createElement("div", { className: "modal zoom-out-entrance", id: "checkoutModal", tabIndex: -1, "aria-labelledby": "checkoutModalLabel", "aria-hidden": "true" },
                React.createElement("div", { className: "modal-dialog position-fixed top-0 start-0 m-3" },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title", id: "checkoutModalLabel" }),
                            this.modalCloseButton()),
                        React.createElement("div", { className: "modal-body py-0" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-6 py-3 bg-primary-sec" },
                                    React.createElement("table", { className: "table table-borderless" },
                                        React.createElement("tbody", null,
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Subtotal', 'المجموع')),
                                                React.createElement("td", { className: "text-white" },
                                                    this.currencyFormatValue(this.state.subtotal),
                                                    React.createElement("div", { className: "small opacity-75" }, this.convertToUSD(this.state.subtotal)))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Quantity', 'الكمية')),
                                                React.createElement("td", { className: "text-white" }, this.state.cart.reduce(function (prev, current) {
                                                    return prev + +(current.quantity || 0);
                                                }, 0))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Discount', 'الخصم')),
                                                React.createElement("td", { className: "text-white" },
                                                    this.currencyFormatValue(this.state.discount || 0),
                                                    React.createElement("div", { className: "small opacity-75" }, this.convertToUSD(this.state.discount || 0)))),
                                            React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Delivery Charge', 'رسوم التوصيل')),
                                                React.createElement("td", { className: "text-white" },
                                                    this.currencyFormatValue(this.state.deliveryCharge || 0),
                                                    React.createElement("div", { className: "small opacity-75" }, this.convertToUSD(this.state.deliveryCharge || 0)))),
                                            this.state.vatType == 'add' ? (React.createElement("tr", null,
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    ' ',
                                                    t('VAT', 'الضريبة'),
                                                    " ",
                                                    this.state.tax || 0,
                                                    "%"),
                                                React.createElement("td", { className: "text-white" },
                                                    this.currencyFormatValue(this.getTotalTax()),
                                                    React.createElement("div", { className: "small opacity-75" }, this.convertToUSD(this.getTotalTax()))))) : (React.createElement(React.Fragment, null,
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec" },
                                                        " ",
                                                        t('Tax Amount', 'القيمة الضريبية')),
                                                    React.createElement("td", { className: "text-white" },
                                                        this.currencyFormatValue(this.getTotalTax()),
                                                        React.createElement("div", { className: "small opacity-75" }, this.convertToUSD(this.getTotalTax())))),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec" },
                                                        t('VAT', 'الضريبة'),
                                                        " ",
                                                        this.state.tax || 0,
                                                        "%"),
                                                    React.createElement("td", { className: "text-white" },
                                                        this.currencyFormatValue(this.getVat()),
                                                        React.createElement("div", { className: "small opacity-75" }, this.convertToUSD(this.getVat())))))),
                                            React.createElement("tr", { className: "fw-bold" },
                                                React.createElement("td", { className: "text-danger-sec" },
                                                    " ",
                                                    t('Total', 'المجموع الإجمالي')),
                                                React.createElement("td", { className: "text-white" },
                                                    this.currencyFormatValue(this.state.total),
                                                    React.createElement("div", { className: "fw-normal small opacity-75" }, this.convertToUSD(this.state.total)))),
                                            this.state.customer && (React.createElement(React.Fragment, null,
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" },
                                                        " ",
                                                        t('Customer', 'الزبون')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.name)),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" }, t('Contact', 'الاتصال')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.contact)),
                                                React.createElement("tr", null,
                                                    React.createElement("td", { className: "text-danger-sec align-middle" }, t('Address', 'العنوان')),
                                                    React.createElement("td", { className: "text-white" }, this.state.customer.full_address)))))),
                                    React.createElement("hr", null),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("label", { htmlFor: "remarks", className: "form-label text-danger-sec" }, t('Notes', 'الملاحظات')),
                                        React.createElement("textarea", { className: "form-control", id: "remarks", rows: 3, onChange: event => this.handleRemarksChange(event) }, this.state.remarks))),
                                React.createElement("div", { className: "col-6 py-3 bg-body d-flex flex-column" },
                                    React.createElement("div", { className: "text-center text-danger" },
                                        " ",
                                        t('CHECKOUT', 'الدفع')),
                                    React.createElement("hr", null),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("div", { className: "form-label text-center" }, t('Tender Amount', 'المبلغ المدفوع')),
                                        React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: (_b = this.state.tenderAmount) === null || _b === void 0 ? void 0 : _b.toFixed(2), onFocus: e => e.target.select(), onChange: this.handleTenderAmountChange }),
                                        React.createElement("div", { className: "text-muted small text-center mt-1" }, this.convertToUSD(this.state.tenderAmount || 0))),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("div", { className: "form-label text-center" }, t('Customer Amount', 'مبلغ العميل')),
                                        React.createElement("input", { type: "number", className: "form-control form-control-lg text-center", value: this.state.customerAmount, onFocus: e => e.target.select(), onChange: this.handleCustomerAmountChange }),
                                        React.createElement("div", { className: "text-muted small text-center mt-1" }, this.convertToUSD(this.state.customerAmount || 0))),
                                    React.createElement("div", { className: "mb-3" },
                                        React.createElement("div", { className: "form-label text-center" }, t('Return', 'مبلغ العميل')),
                                        React.createElement("div", { className: "form-label text-center" }, this.currencyFormatValue(this.state.returnAmount)),
                                        React.createElement("div", { className: "text-muted small text-center" }, this.convertToUSD(this.state.returnAmount || 0))),
                                    React.createElement("hr", null),
                                    React.createElement("table", { className: "table table-borderless d-none" },
                                        React.createElement("tbody", null,
                                            React.createElement("tr", { className: "fw-bold" },
                                                React.createElement("td", { className: "text-danger-sec" }, this.getChangeAmount() < 0 ? t('Owe', 'مدين') : t('Change', 'الباقي')),
                                                React.createElement("td", { className: "text-end" },
                                                    this.currencyFormatValue(this.getChangeAmount()),
                                                    React.createElement("div", { className: "text-muted small" }, this.convertToUSD(this.getChangeAmount())))))),
                                    React.createElement("div", { className: "mt-auto pt-2 bg-body" },
                                        React.createElement("button", { className: "btn btn-primary btn-lg py-3 w-100", disabled: this.state.isLoading, onClick: e => this.storeOrder() }, t('SUBMIT', 'حفظ'))))))))),
            React.createElement(ToastContainer, { position: "top-center", autoClose: 2000, pauseOnHover: true, theme: "colored", hideProgressBar: true })));
    }
}
export default PointOfSale;
const element = document.getElementById('pos');
if (element) {
    const props = Object.assign({}, element.dataset);
    const root = ReactDOM.createRoot(element);
    root.render(React.createElement(PointOfSale, Object.assign({ settings: props.settings, logoUrl: props.logo }, props)));
}
